import { render, staticRenderFns } from "./Ramadan.vue?vue&type=template&id=019853aa"
import script from "./Ramadan.vue?vue&type=script&lang=js"
export * from "./Ramadan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports